export default __webpack_public_path__ + "static/icon-benefits-home-smartphone-97626b677d6a3c82aae6509d9e018d68.png";